<template>
  <v-data-table
    class="mt-4"
    mobile-breakpoint="0"
    :items-per-page="5"
    :options.sync="studentTableOptions"
    item-key="studentCode"
    :headers="originHeaders"
    :items="priceStudent"
    :footer-props="{
      'items-per-page-text': 'Số dòng mỗi trang',
      'items-per-page-all-text': 'Tất cả',
    }"
    disable-sort
  >
    <template v-slot:[`item.index`]="{ item }">
      {{ item.index }}
    </template>
    <template v-slot:[`item.student`]="{ item }">
      <CardStudentName :student="item" link />
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ item.dob | ddmmyyyy }}
    </template>
    <template v-slot:[`item.gender`]="{ item }">
      {{ item.gender | gender }}
    </template>
    <template v-slot:[`item.class`]="{ item }">
      {{ item.currentClass.title }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small :color="item.status | statusColor"
        ><span class="white--text">{{ item.status | status }}</span></v-chip
      >
    </template>
    <template v-slot:[`item.price`]="{ item }">
      <span
        >{{ item.price && item.price.toLocaleString('en-US')
        }}{{ item.price && item.type === 'percentage' ? '%' : ' VNĐ' }}</span
      >
    </template>
  </v-data-table>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    CardStudentName,
  },
  props: {
    priceStudent: Array,
    selected: Boolean,
  },
  data() {
    return {
      originHeaders: [
        { text: 'STT', value: 'index' },
        { text: 'Học viên', value: 'student' },
        { text: 'Ngày sinh', value: 'dob', width: 100 },
        { text: 'Giới tính', value: 'gender' },
        { text: 'Lớp', value: 'class' },
        { text: 'Trạng thái', value: 'status', align: 'center' },
        { text: `Mức thu/giảm`, value: 'price' },
        { text: 'Ghi chú riêng', value: 'notes' },
      ],
      studentTableOptions: {},
    }
  },
  methods: {
    ...mapActions('tuitionFeePriceStudent', ['requestPageSettings']),
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<style>
.text-error {
  color: #fd6b6b;
}
</style>
